__turbopack_context__.v({
  "comboboxContainer": "PlaygroundStartEndSelector-module__GiaDPW__comboboxContainer",
  "countryName": "PlaygroundStartEndSelector-module__GiaDPW__countryName",
  "grey": "PlaygroundStartEndSelector-module__GiaDPW__grey",
  "inputContainer": "PlaygroundStartEndSelector-module__GiaDPW__inputContainer",
  "label": "PlaygroundStartEndSelector-module__GiaDPW__label",
  "pinAndTextContainer": "PlaygroundStartEndSelector-module__GiaDPW__pinAndTextContainer",
  "placeName": "PlaygroundStartEndSelector-module__GiaDPW__placeName",
  "section": "PlaygroundStartEndSelector-module__GiaDPW__section",
  "selectedValue": "PlaygroundStartEndSelector-module__GiaDPW__selectedValue",
  "selectedValueContainer": "PlaygroundStartEndSelector-module__GiaDPW__selectedValueContainer",
});
